//登录
export const USER_LOGIN_SUCCESS="USER_LOGIN_SUCCESS"
export const USER_OUT_LOGIN="USER_OUT_LOGIN"
//菜单折叠
export const MENU_FOLD="MENU_FOLD"
export const MENU_EXPAND="MENU_EXPAND"